import React, { useCallback, useEffect, useState } from "react";
import Table from "../../components/table/Table";
import { useSelector } from "react-redux";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./History.module.css";
import TableLoader from "../../components/ui/TableLoader";

function DebitHistory() {
  const [allTransactions, setAllTransactions] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(allTransactions);
  const [searchInput, setSearchInput] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageIsLoading, setPageIsLoading] = useState(false);

  const token = useSelector((state) => state.userData.loginData.token);

  const fetchCustomers = useCallback(async () => {
    try {
      setPageIsLoading(true);
      const response = await FixedAgent.getManualDebitHistory({
        token,
        page_no: pageNumber,
      });
      setAllTransactions(response.data.data);
      setPageIsLoading(false);
    } catch (error) {
      setPageIsLoading(false);
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token, pageNumber]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const transactions = allTransactions?.data || allTransactions;
    if (searchInput === "") {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions?.filter((customer) =>
        customer.plate_details?.fullname
          ?.toLowerCase()
          ?.includes(searchInput?.toLowerCase())
      );
      setFilteredTransactions(filtered);
    }
  }, [searchInput, allTransactions]);
  return (
    <div>
      <ToastContainer />

      {!pageIsLoading ? (
        <div>
          {" "}
          <div className={styles.filter_wrapper}>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search by buyer's name"
              className={styles.filter_input}
            />
            <button className={styles.export_button}>Export</button>
          </div>
          <div style={{ display: "inline" }}>
            <button
              onClick={() => setPageNumber(pageNumber - 1)}
              disabled={pageNumber === allTransactions?.from}
              style={{
                backgroundColor:
                  pageNumber === allTransactions?.from ? "grey" : "#1814F3",
                color: "white",
                padding: "5px 10px",
                margin: "5px",
                border: "none",
                float: "left",
                borderRadius: "5px",
              }}
            >
              Prev
            </button>
            <button
              onClick={() => setPageNumber(pageNumber + 1)}
              disabled={pageNumber === allTransactions?.last_page}
              style={{
                backgroundColor:
                  pageNumber === allTransactions?.last_page
                    ? "grey"
                    : "#1814F3",
                color: "white",
                padding: "5px 10px",
                margin: "5px",
                border: "none",
                float: "left",
                borderRadius: "5px",
              }}
            >
              Next
            </button>
          </div>
          <Table tableData={filteredTransactions} />
        </div>
      ) : (
        <TableLoader />
      )}
    </div>
  );
}

export default DebitHistory;
